import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import FeaturedSection from '../HousingSection/featured';
import ComfortSection from '../ComfortSection';
import CTABanner from '../ContactSalesBanner';
import FAQSection from '../FAQ';
import WhyBadiPlus from '../WhyBadiPlus';
import RoomCollections from 'app/components/RoomCollections/RoomCollections';

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 4rem 3rem;

  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const Featured = () => {
  return (
    <Container>
      <RoomCollections />
      <FeaturedSection />
      <ComfortSection />
      <WhyBadiPlus />
      <FAQSection mode="badi-plus" />
      <CTABanner />
    </Container>
  );
};

export default connect()(Featured);
